export type FirmaDigitalLeftTab = 'datos' | 'guia' | 'advertencias';
export type FirmaDigitalRightTab =
  | 'observacion'
  | 'agua'
  | 'devolucion'
  | 'firma'
  | 'finalizar';
export type FirmaDigitalFirmaMode = 'chooser' | 'digital' | 'qr' | 'exito';

export interface FirmaDigitalDraft {
  guidingRemarks: string;
  waterAddition: boolean;
  anotherAddition: boolean;
  m3Returned: number | null;
  reasonToReturn: string;
  m3ReturnedPallet: string;
  isSignature: boolean;
  firmaRut: string;
  firmaDv: string;
  firmaNombre: string;
  firmaCorreo: string;
  firmaComentarios: string;
  firmaCanvas: string;
  aguaRut: string;
  aguaDv: string;
  aguaNombre: string;
  aguaCorreo: string;
  aguaComentarios: string;
  aguaCanvas: string;
  aguaSigned: boolean;
  devolucionRut: string;
  devolucionDv: string;
  devolucionNombre: string;
  devolucionCorreo: string;
  devolucionComentarios: string;
  devolucionSigned: boolean;
  papelFileName: string;
}

export function emptyFirmaDigitalDraft(): FirmaDigitalDraft {
  return {
    guidingRemarks: '',
    waterAddition: false,
    anotherAddition: false,
    m3Returned: null,
    reasonToReturn: '',
    m3ReturnedPallet: '',
    isSignature: false,
    firmaRut: '',
    firmaDv: '',
    firmaNombre: '',
    firmaCorreo: '',
    firmaComentarios: '',
    firmaCanvas: '',
    aguaRut: '',
    aguaDv: '',
    aguaNombre: '',
    aguaCorreo: '',
    aguaComentarios: '',
    aguaCanvas: '',
    aguaSigned: false,
    devolucionRut: '',
    devolucionDv: '',
    devolucionNombre: '',
    devolucionCorreo: '',
    devolucionComentarios: '',
    devolucionSigned: false,
    papelFileName: '',
  };
}

export const FIRMA_DIGITAL_ADVERTENCIAS = [
  {
    id: 'docilidad',
    title: 'Ajuste de docilidad',
    text:
      'El ajuste de docilidad se realizará por única vez previo al inicio de la descarga, en un tiempo máximo a 30 minutos desde la hora de llegada a obra y no superior a 90 minutos desde la hora de carga, cualquier adición de agua fuera de estos límites son responsabilidad de quien autoriza el ajuste de docilidad.',
  },
  {
    id: 'devolucion',
    title: 'Devolución de hormigón',
    text:
      'Estimado cliente, recuerde que todo hormigón devuelto tiene un cobro ambiental de 1 UF por m3. Utilice todo el hormigón solicitado.',
  },
  {
    id: 'acuse',
    title: 'Acuse de recibo',
    text:
      'El acuse de recibo que se declara en este acto, de acuerdo a lo dispuesto en la letra b) del artículo 4° y la letra c) del artículo 5° de la ley 19983, acredita que la entrega de mercadería o servicio(s) prestado(s) ha(n) sido recibido(s) conforme a lo solicitado.',
  },
] as const;

/** Advertencias aplicables a la firma de áridos. Docilidad y devolución son exclusivas de hormigón. */
export const FIRMA_ARIDOS_ADVERTENCIAS = FIRMA_DIGITAL_ADVERTENCIAS.filter(
  (item) => item.id === 'acuse',
);
